// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"510":"54c3d2b6","571":"21e1fefe","814":"b33633ed"}[chunkId] + ".css";
};